module.exports = __webpack_public_path__ + "static/media/Image01.240e99eb.png";